import { Product } from "data/products";
import ProductCard from "components/ProductCard";

type ProductGridProps = {
  products: Product[];
};

export default function ProductGrid({ products }: ProductGridProps) {
  return (
    <div className="grid" style={{ marginTop: 12 }}>
      {products.map((product) => (
        <ProductCard key={product.sku} productSpecific={product} />
      ))}
    </div>
  );
}
